import {
  FileTextIcon,
  LightningIcon,
  UsersIcon,
  MoneyIcon,
  FlagIcon,
  PercentIcon,
  WarningIcon,
} from "@phosphor-icons/react";

import { ROUTES_PAYFAC, ROUTES_LEGACY_WEBAPP } from "@payfac/constants";
import { addWithCondition } from "@payfac/helpers";

import type { TFunction } from "i18next";
import type {
  GetRoutesAppFlagsProps,
  SidebarRouteItemProps,
  SidebarSubRouteItemProps,
} from "./sidebar.type";

export const getRoutesApp = (
  t: TFunction,
  {
    isEnableNewRatePlanPage,
    isEnablePendenciesPage,
    isEnableTransactionMetabaseScreen,
    isEnableIndicatorsMetabaseScreen,
    isEnableTerminalsMetabaseScreen,
    isEnableRatePartnersScreen,
    isEnableSellerListScreen,
  }: GetRoutesAppFlagsProps,
): SidebarRouteItemProps[] => [
  {
    title: t("payfac.sidebarDashboardLink"),
    path: ROUTES_LEGACY_WEBAPP.DASHBOARD.fullPath,
    icon: LightningIcon,
    isExternal: true,
    items: [
      isEnableIndicatorsMetabaseScreen
        ? {
            title: t("payfac.sidebarIndicatorsLink"),
            path: ROUTES_PAYFAC.DASHBOARD_INDICATORS.fullPath,
            isExternal: false,
          }
        : {
            title: t("payfac.sidebarIndicatorsLink"),
            path: ROUTES_LEGACY_WEBAPP.DASHBOARD.INDICATORS.fullPath,
          },
      isEnableTerminalsMetabaseScreen
        ? {
            title: t("payfac.sidebarTerminalsLink"),
            path: ROUTES_PAYFAC.DASHBOARD_TERMINALS.fullPath,
            isExternal: false,
          }
        : {
            title: t("payfac.sidebarTerminalsLink"),
            path: ROUTES_LEGACY_WEBAPP.DASHBOARD.TERMINALS.fullPath,
          },
      {
        title: t("payfac.sidebarCommissionsLink"),
        path: ROUTES_PAYFAC.DASHBOARD_COMMISSIONS.fullPath,
        isExternal: false,
      },
    ],
  },
  ...addWithCondition<SidebarRouteItemProps>(
    {
      title: t("payfac.sidebarPendenciesLink"),
      path: ROUTES_PAYFAC.PENDENCIES.fullPath,
      icon: WarningIcon,
      isExternal: false,
    },
    isEnablePendenciesPage,
  ),
  isEnableSellerListScreen
    ? {
        title: t("payfac.sidebarSellersLink"),
        path: ROUTES_PAYFAC.SELLERS.fullPath,
        icon: UsersIcon,
        isExternal: false,
      }
    : {
        title: t("payfac.sidebarSellersLink"),
        path: ROUTES_LEGACY_WEBAPP.SELLERS.fullPath,
        icon: UsersIcon,
        isExternal: true,
      },
  ...addWithCondition<SidebarRouteItemProps>(
    {
      title: t("payfac.sidebarTransactionsLink"),
      path: ROUTES_PAYFAC.TRANSACTIONS.fullPath,
      icon: MoneyIcon,
      isExternal: false,
    },
    isEnableTransactionMetabaseScreen,
  ),
  {
    title: t("payfac.sidebarChargebacksLink"),
    path: ROUTES_LEGACY_WEBAPP.CHARGEBACKS.fullPath,
    icon: FlagIcon,
    isExternal: true,
  },
  ...addWithCondition<SidebarRouteItemProps>(
    {
      title: t("payfac.sidebarRatesLink"),
      path: ROUTES_PAYFAC.RATE_PLANS.fullPath,
      icon: PercentIcon,
      isExternal: false,
      items: [
        ...addWithCondition<SidebarSubRouteItemProps>(
          {
            title: t("payfac.sidebarRatePlansLink"),
            path: ROUTES_PAYFAC.RATE_PLANS.fullPath,
          },
          isEnableNewRatePlanPage,
        ),
        ...addWithCondition<SidebarSubRouteItemProps>(
          {
            title: t("payfac.sidebarPartnersLink"),
            path: `${ROUTES_LEGACY_WEBAPP.fullPath}partners`,
            isExternal: true,
          },
          isEnableRatePartnersScreen,
        ),
        ...addWithCondition<SidebarSubRouteItemProps>(
          {
            title: t("payfac.sidebarNegotiationsLink"),
            path: `${ROUTES_LEGACY_WEBAPP.fullPath}negotiations`,
            isExternal: true,
          },
          isEnableRatePartnersScreen,
        ),
      ],
    },
    isEnableNewRatePlanPage || isEnableRatePartnersScreen,
  ),
  {
    title: t("payfac.sidebarReportsLink"),
    path: ROUTES_PAYFAC.REPORTS.fullPath,
    icon: FileTextIcon,
    isExternal: false,
  },
];
